import theme from "@/styles/themes/theme";
import { css } from "@emotion/react";

export const styles = {
  inforimage: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 0;
  `,
  image: css`
    width: 100% !important;
    max-height: 600px;
    height: auto !important;
  `,
  informsg: css`
    font-weight: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 3rem 5rem;
    font-size: 1rem;
    background-color: ${theme.palette.grey[200]};
    color: ${theme.palette.grey[800]};
    @media (max-width: 600px) {
      padding: 2rem 1rem;
    }
  `,
  inforlist: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 3rem;
    margin: 3rem;

    @media (max-width: 600px) {
      flex-direction: column;
    }
    ul,
    ol {
      padding-inline-start: 15px;
    }
  `,

  inforbutton: css`
    color: ${theme.palette.common.black};
    width: 3000;
  `,

  infordivider: css`
    margin-left: 6px;
    margin-right: 3px;
    border: 1px solid rgba(0, 0, 0, 0.088);

    @media (max-width: 600px) {
      display: none;
    }
  `
};
